import {FIXTURE_STATE_CONFIG} from "@/utils/constants.js";


export const formatTeamName = (name) => {
    if (!name) return '';

    const parts = name.split(' ');

    if (parts.length > 1) {
        return `${parts[0].charAt(0)}. ${parts.slice(1).join(' ')}`;
    }

    return name;
};

export const getBetTimeLabel = (betDateString, matchDateString, t) => {
    if (!betDateString || !matchDateString) return '-';

    const betDate = new Date(betDateString);
    const matchDate = new Date(matchDateString);

    if (betDate < matchDate) {
        return t('bet_history.pre_match');
    }

    const diffMs = betDate - matchDate;
    const diffMins = Math.floor(diffMs / (1000 * 60));

    return t('bet_history.live_minute', {minute: diffMins});
};

export const getFixtureDisplay = (type, status, minutes, extraMinutes, t) => {

    let color = 'bg-gray-100 text-gray-500';
    let label = t(`fixture_state.${status}`) || status; // Tente de traduire, sinon affiche le code
    let isLive = false;

    switch (status) {

        // --- À VENIR ---
        case FIXTURE_STATE_CONFIG.NOT_STARTED:
            break;

        // --- EN COURS (Rouge & Actif) ---
        case FIXTURE_STATE_CONFIG.FIRST_HALF:
        case FIXTURE_STATE_CONFIG.SECOND_HALF:
        case FIXTURE_STATE_CONFIG.EXTRA_TIME:
        case FIXTURE_STATE_CONFIG.PENALTY_SHOOTOUT:
            color = 'bg-red-50 text-red-500';
            isLive = true;
            break;

        case FIXTURE_STATE_CONFIG.HALF_TIME:
            color = 'bg-orange-50 text-orange-500';
            isLive = true;
            break;
        case FIXTURE_STATE_CONFIG.BREAK_TIME:
            color = 'bg-yellow-50 text-yellow-600';
            isLive = true;
            break;

        case FIXTURE_STATE_CONFIG.FULL_TIME:
        case FIXTURE_STATE_CONFIG.FINISHED_AFTER_EXTRA_TIME:
        case FIXTURE_STATE_CONFIG.FINISHED_AFTER_PENALTIES:
            color = 'bg-slate-100 text-slate-600';
            isLive = false;
            break;

        case FIXTURE_STATE_CONFIG.POSTPONED:
        case FIXTURE_STATE_CONFIG.CANCELLED:
            color = 'bg-gray-200 text-gray-500 line-through';
            isLive = false;
            break;

        case FIXTURE_STATE_CONFIG.ABANDONED:
        case FIXTURE_STATE_CONFIG.WALKOVER:
            color = 'bg-gray-200 text-gray-500';
            isLive = false;
            break;

        default:
            console.warn(`Statut de match inconnu: ${status}`);
    }

    if (isLive && minutes && type !== 'RUGBY') {
        let timeLabel = `${minutes}'`;
        if (extraMinutes && extraMinutes > 0) {
            timeLabel += `+${extraMinutes}'`;
        }

        label = t('fixture_state.live_timer', {time: timeLabel});
    }

    return {label, color, isLive};
};